import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cva } from 'class-variance-authority';
import { useTranslation } from 'next-i18next';
import { twMerge } from 'tailwind-merge';

import { CHANNEL, vacanciesSlugs } from '@boss/constants/corporate-jobs';
import { IIVacancy } from '@boss/types/corporate-jobs';
import { Button, JobBlock } from '@boss/ui';
import { slugify } from '@boss/utils';

import { mapContentfulToNextLocale } from '../../utils/localeMapper';

type Props = {
  highlightedJobs: IIVacancy[];
  locale: string;
  textClassName?: string;
};

const wrapperStyling = cva('', {
  variants: {
    variant: {
      b2b: '',
      b2c: 'py-12 bg-background break-before before:bg-background break-after after:bg-background relative',
    },
  },
});

const HighLightedJobs = ({ highlightedJobs, locale, textClassName }: Props) => {
  const { t } = useTranslation(['jobs']);

  return (
    <div className={wrapperStyling({ variant: CHANNEL === 'jobs-b2c' ? 'b2c' : 'b2b' })}>
      {highlightedJobs.map((job, index) => (
        <JobBlock
          className={twMerge('mb-6', textClassName)}
          cta={{
            alternativeText: null,
            anchorClassName: '',
            href: job?.functieTitel
              ? `${vacanciesSlugs[mapContentfulToNextLocale(locale)]}/${slugify(job.functieTitel)}/${job.vacatureId}`
              : undefined,
            icon: undefined,
            iconPosition: 'left',
            label: t('applyButton'),
            type: 'primary',
          }}
          image={{
            imageAlt: t('paintDrop'),
            imageUrl: `/images/paintdrops/${index % 10}.png`,
            id: job?.vacatureId?.toString(),
          }}
          key={job?.vacatureId}
          location={job?.plaatsTewerkstelling?.gemeente}
          title={job?.functieTitel}
          variant={CHANNEL === 'jobs-b2c' ? 'b2c' : 'b2b'}
        />
      ))}
      <div className="flex flex-row items-center">
        <Button
          className="w-fit"
          href={vacanciesSlugs[mapContentfulToNextLocale(locale)]}
          label={t('highlightedLink')}
          labelClassName="w-auto"
          type="link"
        />
        {CHANNEL === 'jobs-b2c' && <FontAwesomeIcon icon={faArrowRight} />}
      </div>
    </div>
  );
};

export default HighLightedJobs;
